<div class="privacy-policy-page-container only-header-section-page">
    <header class="red-to-purlpe-gradient">
        <i18n-html-content-loader-control
            [filePostFix]="'privacy-policy'"></i18n-html-content-loader-control>
    </header>
</div>
